/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-facebook': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.669 2.5H3.33a.838.838 0 00-.831.831V16.67a.837.837 0 00.831.831h7.181v-5.8h-1.95v-2.27h1.95V7.763c0-1.938 1.182-2.994 2.92-2.994.58 0 1.162 0 1.743.087v2.019H13.98c-.944 0-1.125.45-1.125 1.106v1.444h2.25l-.293 2.269h-1.957V17.5h3.813a.837.837 0 00.831-.831V3.33a.837.837 0 00-.831-.831z"/>'
  }
})
